<script>
import API from '../services/api';

const api = new API();

module.exports = {
  template: '#feedback-template',
  data: function() {
    return {
      errors: {},
      values: {
        store: {
          value: '',
          text: 'Valitse'
        },
        department: {
          value: '',
          text: 'Valitse'
        },
        subject: {
          value: '',
          text: 'Valitse'
        },
        rating: {
          value: ''
        },
        feedback: {
          value: ''
        }
      },
      send: false
    };
  },
  methods: {
    submitFeedbackForm: function() {
      for (let key in this.values) {
        let el = this.values[key];
        if (el.value === '' && key !== 'rating') this.errors[key] = true;

        else delete this.errors[key];
      }

      if (Object.keys(this.errors).length === 0)
        api.sendFeedback(this.values).then(res => {
          if (res.status == 1) this.send = true;
        });

      this.$forceUpdate();
    }
  },
  computed: {
    formData: function() {
      return {
        stores: this.$store.state.stores.reduce((result, store) => {
          if (store.dealer_id != '') result.push(store);
          return result;
        }, []),
        departments: [
          {
            value: 'automyynti',
            text: 'Automyynti'
          },
          {
            value: 'huolto',
            text: 'Huolto'
          },
          {
            value: 'varaosat',
            text: 'Varaosat'
          },
          {
            value: 'korikorjaamo',
            text: 'Korikorjaamo'
          },
          {
            value: 'muu',
            text: 'Muu'
          }
        ],
        subjects: [
          {
            value: 'palvelun_laatu',
            text: 'Palvelun laatu'
          },
          {
            value: 'tyon_laatu',
            text: 'Työn laatu'
          },
          {
            value: 'tuotteen_laatu',
            text: 'Tuotteen laatu'
          },
          {
            value: 'hinta',
            text: 'Hinta'
          },
          {
            value: 'toimitilat',
            text: 'Toimitilat'
          },
          {
            value: 'muu',
            text: 'Muu'
          }
        ],
        ratings: [
          {
            value: 'erittain_surullinen'
          },
          {
            value: 'surullinen'
          },
          {
            value: 'iloinen'
          },
          {
            value: 'erittain_iloinen'
          }
        ],
        feedback: {
          value: ''
        }
      };
    }
  }
};
</script>